import { render, staticRenderFns } from "./Decentralized.vue?vue&type=template&id=89636b32&scoped=true"
import script from "./Decentralized.vue?vue&type=script&lang=js"
export * from "./Decentralized.vue?vue&type=script&lang=js"
import style0 from "./Decentralized.vue?vue&type=style&index=0&id=89636b32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89636b32",
  null
  
)

export default component.exports